import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";

const PieChart = ({ reportExtractData }) => {
  const [equity, setEquity] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const equity = reportExtractData?.riskValues.filter(x => x.name === "equity");
    setEquity(equity[0]?.values[0]);
    setTotal(reportExtractData?.totals[0])
  }, []);
  var optionsPie = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        rtl: true,
      }
    },
  };

  const data = {
    datasets: [
      {
        label: 'Popularity of colours',
        data: [total, equity],
        backgroundColor: [
          '#122e47',
          '#8bfbe8',
        ],
        borderWidth: 1,
      }]
  }
  const pieChartData = reportExtractData.riskValues.filter(x => x.level === 1 && x.name !== "Not Applicable").reverse();

  var name = [];
  var colors = ['#003f5c', '#8bfbe8', '#d4d4d4', '#2c4875', '#8a508f', '#000000', '#bc5090', '#ff6361', '#ff8531', '#ffa600', '#ffd380', '#1b4552', '#476f95'];
  var pieChartValue = [];

  pieChartData.map((data) => {
    return (
      name?.push(data.name),
      pieChartValue.push(data?.values[0])
    )
  });
  const riskValues = {
    labels: name,
    datasets: [
      {
        label: 'Popularity of colours',
        data: pieChartValue,
        backgroundColor: colors,
        borderWidth: 1,
      }]
  }
  return (
    <div>
      <div className="col-lg-12">
        <div style={{ marginLeft: "10px", padding: "20px", paddingBottom: "0px", marginBottom: "30px" }}>Total Market</div>
        <div className="row">
          <div className="col-lg-6">
            <Pie data={data} options={optionsPie} />
          </div>
          <div className="col-lg-6" style={{ marginTop: "5%" }}>
            <div className="row">
              <div className="col-lg-3" style={{ width: "30px", height: "20px", backgroundColor: "#8bfbe8" }}></div>
              <div className="col-lg-9">
                <p style={{ marginBottom: "30px" }}>Equity : <small>{equity?.toFixed(0)}</small></p>
              </div>
              <div className="col-lg-3" style={{ width: "30px", height: "20px", backgroundColor: "#122e47" }}></div>
              <div className="col-lg-9">
                <p>Total : <small>{total?.toFixed(0)}</small></p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <hr />
        <div className="row">
          <div style={{ marginLeft: "10px", padding: "20px", paddingBottom: "0px" }}>Market Sectors</div>
          <div className="col-lg-12" >
            <Pie data={riskValues} height={500}
              width={300} options={optionsPie} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieChart;
